module.exports = __webpack_public_path__ + "media/images/tutorialSlide__screenshot1-cb0d57a4e3eef615269cb2b6f1fada1e.png";